import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const trafficAnalysis = createApi({
  baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
  reducerPath: 'api.trafficAnalysis',
  tagTypes: ['trafficAnalysis'],
  endpoints: (builder) => ({
    getStatsDash: builder.query<any, { compareStartDate: string | null, compareEndDate: string | null, startDate: string | null, endDate: string | null, device: string[] | null, countries: string[], keywords: string[], timestep: string, workspaceId: any | null, platform: any }>({
      query: ({ startDate, endDate, device, countries, keywords, timestep, compareStartDate, compareEndDate, workspaceId, platform }) => {
        const url = `/trafficAnalysis/getStats`;
        const body = {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          device,
          countries,
          keywords,
          timestep,
          workspaceId,
          platform
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
    getStatsDashCustom: builder.query<any, { compareStartDate: string | null, compareEndDate: string | null, startDate: string | null, endDate: string | null, device: string[] | null, countries: string[], keywords: string[], timestep: string, workspaceId: any | null, platform: any }>({
      query: ({ startDate, endDate, device, countries, keywords, timestep, compareStartDate, compareEndDate, workspaceId, platform }) => {
        const url = `/trafficAnalysis/getStatsCustom`;
        const body = {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          device,
          countries,
          keywords,
          timestep,
          platform,
          workspaceId
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),

    getKpis: builder.query<any, {
      compareStartDate: string | null,
      compareEndDate: string | null,
      startDate: string | null,
      endDate: string | null,
      devices: string[] | null,
      countries: string[],
      keywords: string[],
      timestep: string,
      workspaceId: any | null, 
      platforms: any,
      tags: any[] }>({
      query: ({ startDate, endDate, devices, countries, keywords, timestep, compareStartDate, compareEndDate, workspaceId, platforms, tags }) => {
        const url = `/trafficAnalysis/query/kpis`;
        const body = {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          devices,
          countries,
          keywords,
          timestep,
          workspaceId,
          platforms
        };

        return {
          url,
          method: 'POST',
          params: {
            tags,
          },
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
  }),
});

export const {
  useGetStatsDashQuery,
  useGetStatsDashCustomQuery,
  useGetKpisQuery
} = trafficAnalysis;

export default trafficAnalysis;
